export type CalculateTimeLeftResult = {
    days: string;
    hours: string;
    minutes: string;
    seconds: string;
    isTimeUp: boolean;
    isValidDate: boolean;
};

export const calculateTimeLeft = (dateTo: string, isDisplayDay = false): CalculateTimeLeftResult => {
    const defaultTimeLeft: CalculateTimeLeftResult = {
        days: '0',
        hours: '0',
        minutes: '00',
        seconds: '00',
        isTimeUp: true,
        isValidDate: false,
    };
    const currentDate = new Date();
    const targetDate = new Date(dateTo);
    if (isNaN(targetDate.getTime())) {
        return defaultTimeLeft;
    }
    const timeLeft = targetDate.getTime() - currentDate.getTime();

    if (timeLeft <= 0) {
        defaultTimeLeft.isValidDate = true;
        return defaultTimeLeft;
    }

    const days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
    const hours = isDisplayDay ? Math.floor((timeLeft / 1000 / 60 / 60) % 24) : Math.floor(timeLeft / (1000 * 60 * 60));
    const minutes = Math.floor((timeLeft / 1000 / 60) % 60);
    const seconds = Math.floor((timeLeft / 1000) % 60);

    const calculateTimeLeftResult = {
        days: (days < 10 ? '0' : '') + days,
        hours: (hours < 10 ? '0' : '') + hours,
        minutes: ('0' + minutes).slice(-2),
        seconds: ('0' + seconds).slice(-2),
        isTimeUp: false,
        isValidDate: true,
    };
    return calculateTimeLeftResult;
};

export const calculateTimePass = (dateFrom: string, dateTo: string): number => {
    const fromDate = new Date(dateFrom);
    const toDate = new Date(dateTo);
    const fromDateMilliseconds = fromDate.getTime();
    const toDateMilliseconds = toDate.getTime();

    if (isNaN(fromDateMilliseconds) || isNaN(toDateMilliseconds)) {
        return 0;
    }

    const currentDate = new Date();

    if (fromDate > currentDate) {
        return 0;
    } else if (currentDate > toDate) {
        return 100;
    }

    const currentDateMilliseconds = currentDate.getTime();
    const totalTime = toDateMilliseconds - fromDateMilliseconds;
    const timePassed = currentDateMilliseconds - fromDateMilliseconds;
    const percentagePassed = (timePassed / totalTime) * 100;

    return percentagePassed;
};
